import Vue from 'vue'

export default {

  sendMessage (data) {
    return Vue.axios.post('/messages', { 'body': data })
  },

  getMessages () {
    return Vue.axios.get('/messages')
  }
}
